import axios from 'axios'

const API_PATH = 'admins/catalog/products'

const CatalogProductsApi = {
  /**
   * Update ::Product.is_refundable
   * @param {number} id - represent ::Product.id
   * @param {boolean} isRefundable - new value for ::Product.is_refundable
   */
  updateIsRefundable: async ({
    id,
    isRefundable
  }) => {
    const endpoint = `${API_PATH}/${id}/refundable`
    const params   = {
      is_refundable: isRefundable
    }
    const response = axios.patch(endpoint, params)
    return response
  },

  /**
   * Update ::Product.is_refundable
   * @param {number} id - represent ::Product.id
   * @param {string} nonrefundableReasons - reason why ::Product is nonrefundable
   */
  updateNonRefundableReasons: async ({
    id,
    nonrefundableReasons
  }) => {
    const endpoint = `${API_PATH}/${id}/nonrefundable_reasons`
    const params   = {
      nonrefundable_reasons: nonrefundableReasons
    }
    const response = axios.patch(endpoint, params)
    return response
  },

  /**
   * Get all ::TlBrandClassification
   * @return {array} tl_brand_classification
   */
  getTlBrandClassification: async () => {
    const path     = `${API_PATH}/tl_brand_classifications`
    const response = axios.get(path)
    return response
  }
}

export default CatalogProductsApi
